export class GetMemberResourcesRequest {
    constructor(searchText: string, categorySearch: number) {
        this.categorySearch = categorySearch;
        this.searchText = searchText;
    }
    categorySearch: number;
    searchText: string;
}